module.exports = __webpack_public_path__ + "img/25.230980de.png";